import * as tslib_1 from "tslib";
import { AfterViewChecked, ElementRef, EventEmitter, OnDestroy, OnInit, QueryList } from '@angular/core';
import { Router } from '@angular/router';
import { DataMaterialsService } from '@components/materials/data-materials.service';
import { GlobalDataService } from '@providers/global-data/global-data.service';
import { ModelsToolsService } from '@providers/models-tools/models-tools.service';
var MenuComponent = /** @class */ (function () {
    function MenuComponent(router, globalDataService, dataMaterialsService, modelsToolsService) {
        this.router = router;
        this.globalDataService = globalDataService;
        this.dataMaterialsService = dataMaterialsService;
        this.modelsToolsService = modelsToolsService;
        this.closeMenu = new EventEmitter();
        this.routes = [];
    }
    MenuComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.globalDataService.getCurrentProject().subscribe(function (project) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!project || this.currentProject) {
                            return [2 /*return*/];
                        }
                        this.currentProject = project;
                        this.dataMaterialsService.currentProject = project;
                        return [4 /*yield*/, this.dataMaterialsService.computeProjectMaterialsData()];
                    case 1:
                        _a.sent();
                        this.dataMaterialsService.refreshData = false;
                        this.routes = [
                            {
                                badge: 0,
                                href: "/projects/" + project.id + "/dashboard",
                                key: 'dashboard',
                                label: 'Accueil',
                                active: this.router.isActive("/projects/" + project.id + "/dashboard", false)
                            },
                            {
                                label: 'Documents',
                                badge: 0,
                                href: "/projects/" + project.id + "/files",
                                key: 'files',
                                active: this.router.isActive("/projects/" + project.id + "/files", false)
                            },
                            {
                                label: 'Devis',
                                badge: 0,
                                href: "/projects/" + project.id + "/quotations",
                                key: 'quotations',
                                active: this.router.isActive("/projects/" + project.id + "/quotations", false)
                            },
                            {
                                label: 'Matériaux',
                                badge: 0,
                                href: "/projects/" + project.id + "/materials/orders",
                                key: 'materials',
                                active: this.router.isActive("/projects/" + project.id + "/materials/orders", false),
                                show: this.dataMaterialsService.hasProjectMaterials()
                            },
                            {
                                label: 'Planning',
                                badge: 0,
                                href: "/projects/" + project.id + "/schedule",
                                key: 'schedule',
                                active: this.router.isActive("/projects/" + project.id + "/schedule", false)
                            },
                            {
                                label: 'Financier',
                                badge: 0,
                                href: "/projects/" + project.id + "/balance",
                                key: 'balance',
                                active: this.router.isActive("/projects/" + project.id + "/balance", false)
                            },
                            {
                                label: 'Chantier',
                                badge: 0,
                                href: "/projects/" + project.id + "/chantier",
                                key: 'chantier',
                                active: this.router.isActive("/projects/" + project.id + "/chantier", false)
                            },
                            {
                                label: 'Catalogue',
                                badge: 0,
                                href: "/projects/" + project.id + "/showrooms",
                                key: 'showroom',
                                active: this.router.isActive("/projects/" + project.id + "/showrooms", false)
                            }
                        ];
                        this.filterNavBar();
                        if (!this.routeObs$) {
                            this.routeObs$ = this.router.events.subscribe(function (val) {
                                _this.routes = tslib_1.__spread(_this.routes).map(function (route) {
                                    var newRoute = tslib_1.__assign({}, route);
                                    newRoute.active = _this.router.isActive(route.href, false);
                                    return newRoute;
                                });
                            });
                        }
                        return [2 /*return*/];
                }
            });
        }); });
    };
    MenuComponent.prototype.ngOnDestroy = function () {
        if (this.routeObs$) {
            this.routeObs$.unsubscribe();
        }
    };
    MenuComponent.prototype.filterNavBar = function () {
        if (this.currentProject && this.globalDataService.steps) {
            var currentStep = this.currentProject._related.steps[0];
            if (currentStep) {
                if (!this.modelsToolsService.isStepValid(currentStep.id)) {
                    this.routes = [];
                }
                else if (this.globalDataService.checkStepIsBefore(currentStep.slug, 'handoff_meeting')) {
                    this.routes = this.routes.filter(function (r) { return r.key !== 'chantier' && r.key !== 'balance'; });
                }
            }
        }
        this.routes = this.routes.filter(function (r) { return r.show === undefined || r.show === true; });
    };
    MenuComponent.prototype.menuClicked = function (route) {
        this.routes = this.routes.map(function (r) {
            r.active = (r.key === route.key);
            return r;
        });
        this.closeMenu.emit(route.label);
    };
    MenuComponent.prototype.ngAfterViewChecked = function () {
        this.selectWithPath(window.location.pathname);
    };
    MenuComponent.prototype.selectWithPath = function (path) {
        var _this = this;
        var selectedKey;
        this.routes.forEach(function (route) {
            if (path.includes(route.href)) {
                selectedKey = route.key;
            }
        });
        this.items.toArray().map(function (item) {
            _this.unselect(item.nativeElement);
            var key = item.nativeElement.getAttribute('data-key');
            if (key === selectedKey) {
                _this.select(item.nativeElement);
            }
        });
    };
    MenuComponent.prototype.unselect = function (target) {
        if (target.classList.contains('selected')) {
            target.classList.remove('selected');
        }
    };
    MenuComponent.prototype.select = function (target) {
        if (!target.classList.contains('selected')) {
            target.classList.add('selected');
        }
    };
    MenuComponent.prototype.getIcon = function (route) {
        var icon = [];
        switch (route.key) {
            case 'dashboard':
                icon = ['fal', 'home'];
                break;
            case 'files':
                icon = ['fal', 'folders'];
                break;
            case 'quotations':
                icon = ['fal', 'file-invoice-dollar'];
                break;
            case 'balance':
                icon = ['fal', 'file-invoice-dollar'];
                break;
            case 'materials':
                icon = ['fal', 'tools'];
                break;
            case 'schedule':
                icon = ['fal', 'calendar-check'];
                break;
            case 'pictures':
                icon = ['fal', 'images'];
                break;
            case 'chantier':
                icon = ['fal', 'tasks'];
                break;
            case 'showroom':
                icon = ['fal', 'lamp-floor'];
                break;
            default:
                break;
        }
        return icon;
    };
    return MenuComponent;
}());
export { MenuComponent };
